/*
  Selector de acabado con miniaturas: el puente con el selector nativo de Dawn.

  Lo pinta snippets/av-acabados.liquid, y SOLO en las fichas de «La colección
  eterna». Aquí no se cambia de variante a mano: al pulsar una miniatura se
  marca el radio que le corresponde en el <variant-selects> escondido y se
  dispara su 'change'. Dawn se encarga del resto —precio, botón de compra, URL
  y el salto de la galería a la foto de la variante—, que es exactamente lo que
  se quería y lo que no conviene reimplementar.

  POR QUÉ ESTO VIVE EN UN ARCHIVO APARTE Y NO EN EL SNIPPET: Dawn sustituye el
  <variant-selects> en cada cambio de variante, y cuando el selector de color
  de las prendas repinta la sección entera, el HTML nuevo entra por el DOM y los
  <script> que lleve dentro NO se ejecutan. Ver 'scripts-en-bloques-repintados'.

  POR QUÉ LOS OYENTES CUELGAN DE document Y NO DE LAS MINIATURAS: por lo mismo.
  Unos oyentes puestos sobre los nodos morirían con el primer repintado. Se
  registran una sola vez y se busca el nodo en el momento de pulsar.

  LA GALERÍA LA MUEVE ESTE GUION, Y ES LA EXCEPCIÓN A LO DE ARRIBA. Dawn no
  desplaza el carrusel: lo reordena. Sube la foto de la variante elegida al
  primer puesto -setActiveMedia con prepend- y, con hide_variants, esconde las
  de los demás acabados. En estas fichas se quiere justo lo contrario: todas las
  fotos presentes y siempre en el mismo orden, y que el carrusel se desplace
  hasta la del acabado. Así que product-media-gallery las pinta con orden fijo y
  aquí se anula el setActiveMedia de ese <media-gallery>. Ver 'anular'.

  LA PINTADA DEL ESTADO ACTIVO NO SE HACE EN EL CLIC, se hace al oír el
  'change'. Así hay un solo camino: venga el cambio de una miniatura, del
  selector nativo o de cualquier otro sitio, el subrayado de la fila sale de la
  misma lectura del radio marcado y no puede desincronizarse.
*/
(function () {
  if (window.avAcabados) return;
  window.avAcabados = true;

  var FILA = '.av-acabados';
  var CHIP = '.av-acabado';

  function raiz(nodo) {
    return nodo.closest('product-info') || nodo.closest('.shopify-section') || document;
  }

  /* Busca el radio del selector nativo por el ID del valor de opción, que es lo
     que Dawn imprime en data-option-value-id. Por nombre visible funcionaría
     hoy, pero un acento escapado de distinta forma en los dos sitios lo
     rompería sin ruido. */
  function radioDe(caja, ov) {
    return raiz(caja).querySelector(
      'variant-selects input[type="radio"][data-option-value-id="' + ov + '"]'
    );
  }

  /* Repinta la fila a partir del radio que esté marcado. Si no hay ninguno
     -Dawn puede dejar el selector sin marcar cuando la combinación no existe-
     se deja la fila como estaba: mejor eso que quitar el subrayado a todas y
     dar a entender que no hay nada elegido. */
  function sincronizar(caja) {
    var marcado = raiz(caja).querySelector('variant-selects input[type="radio"]:checked');
    if (!marcado) return;
    var ov = marcado.getAttribute('data-option-value-id');

    caja.querySelectorAll(CHIP).forEach(function (chip) {
      var activo = chip.dataset.ov === ov;
      chip.classList.toggle('av-acabado--activo', activo);
      if (activo) {
        chip.setAttribute('aria-current', 'true');
      } else {
        chip.removeAttribute('aria-current');
      }
    });

    var actual = caja.querySelector('.av-acabados__actual');
    if (actual) actual.textContent = marcado.value;
  }

  /* Deja mudo el setActiveMedia de ESTA galería, y solo de ella: se sustituye
     en la instancia, no en el prototipo, así que las demás fichas de la tienda
     siguen con el de Dawn intacto.

     Por qué hace falta: después de cada cambio de variante, product-info.js lo
     llama con prepend=true, y eso mueve la foto de la variante al primer puesto
     del carrusel. El orden dejaría de ser estable y las fotos bailarían con
     cada acabado, que es lo que se quiere evitar. El desplazamiento y la marca
     de activa los hace 'irAlSlide', aquí abajo.

     Es seguro dejarlo mudo porque en estas fichas solo hay dos quien lo llame:
     ese product-info.js y los botones de las miniaturas de Dawn, que con
     gallery_layout 'stacked' y mobile_thumbnails 'hide' ni siquiera se pintan.

     La galería sobrevive a los cambios de variante -product-info mueve los <li>
     de dentro, no sustituye el elemento-, pero se comprueba en cada clic por si
     un repintado mayor la hubiera repuesto. */
  function anular(galeria) {
    if (!galeria || galeria.avMudo) return;
    galeria.avMudo = true;
    galeria.setActiveMedia = function () {};
  }

  /* Desplaza el carrusel hasta el slide del acabado y le pasa la marca de
     activa. El desplazamiento horizontal se calcula restando la posición del
     primer slide, no con el offsetLeft pelado: la lista lleva relleno lateral
     para que asome la foto siguiente, y sin restarlo se pasa de largo por ese
     mismo margen. Es la cuenta que ya usa av-galeria-puntos. */
  function irAlSlide(caja, idMedia) {
    if (!idMedia) return;
    var galeria = raiz(caja).querySelector('media-gallery');
    if (!galeria) return;
    anular(galeria);

    var lista = galeria.querySelector('.product__media-list');
    if (!lista) return;
    var slide = lista.querySelector('[data-media-id="' + idMedia + '"]');
    if (!slide) return;

    lista.querySelectorAll('[data-media-id]').forEach(function (li) {
      li.classList.toggle('is-active', li === slide);
    });

    /* En móvil la lista se desliza en horizontal. En escritorio el diseño es
       'stacked' y las fotos van apiladas: ahí no hay nada que deslizar y lo que
       procede es traer la foto a la vista, y solo si no se ve ya. */
    if (lista.scrollWidth > lista.clientWidth + 2) {
      var primero = lista.querySelector('[data-media-id]');
      lista.scrollTo({ left: slide.offsetLeft - primero.offsetLeft, behavior: 'smooth' });
    } else {
      slide.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest ? e.target.closest(CHIP) : null;
    if (!chip) return;
    var caja = chip.closest(FILA);
    if (!caja) return;

    var radio = radioDe(caja, chip.dataset.ov);

    /* Sin radio no se puede cambiar de variante sin recargar. En vez de dejar
       la miniatura muerta, se deja que el enlace haga su trabajo: recarga la
       ficha en ?variant=, que es el mismo destino por el camino lento. */
    if (!radio) return;

    e.preventDefault();

    /* El carrusel se mueve siempre, incluso si el acabado ya estaba elegido:
       puede que la clienta haya deslizado hasta otra foto y vuelva a pulsar
       para regresar a la suya. Y se mueve ANTES de pedir nada, así que no
       espera al ida y vuelta con Shopify. */
    irAlSlide(caja, chip.dataset.media);

    if (radio.checked) return;

    caja.classList.add('av-acabados--cargando');
    radio.checked = true;
    /* Burbujea a propósito: el oyente está en el <variant-selects>, que es
       antepasado del radio, y es ahí donde Dawn arranca el cambio. */
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (e) {
    var destino = e.target;
    if (!destino.matches || !destino.matches('variant-selects input[type="radio"]')) return;
    var caja = raiz(destino).querySelector(FILA);
    if (caja) sincronizar(caja);
  });

  /* El velo de "cargando" se quita cuando Dawn termina de traer la sección.
     variantChange es su propio bus, no un evento del DOM, así que se escucha
     con su subscribe. El plazo de seguridad está porque un fallo de red no
     publica nada y la fila se quedaría a medio tono para siempre. */
  function quitarVelo() {
    document.querySelectorAll(FILA + '.av-acabados--cargando').forEach(function (caja) {
      caja.classList.remove('av-acabados--cargando');
    });
  }

  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, quitarVelo);
    }
  } catch (err) {
    /* Sin el bus, se queda el plazo de abajo. */
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest(CHIP)) window.setTimeout(quitarVelo, 4000);
  });

  /* Al entrar por un enlace ?variant= -uno compartido, o el camino sin
     JavaScript- el acabado elegido puede no ser el primero del carrusel, y la
     ficha se abriria diciendo «Color: Negro» con la foto del Oro delante. Se
     coloca el carrusel en su sitio, sin animacion y sin tocar el desplazamiento
     de la pagina: solo la lista horizontal del movil. En escritorio las fotos
     van apiladas y ya se ven todas, asi que no hay nada que colocar y mover la
     ventana al cargar seria peor que el problema. */
  function alinearAlCargar() {
    document.querySelectorAll(FILA).forEach(function (caja) {
      var elegido = caja.querySelector(CHIP + '[aria-current="true"]');
      if (!elegido) return;
      var galeria = raiz(caja).querySelector('media-gallery');
      if (!galeria) return;
      anular(galeria);

      var lista = galeria.querySelector('.product__media-list');
      if (!lista || lista.scrollWidth <= lista.clientWidth + 2) return;
      var slide = lista.querySelector('[data-media-id="' + elegido.dataset.media + '"]');
      var primero = lista.querySelector('[data-media-id]');
      if (!slide || !primero || slide === primero) return;

      lista.querySelectorAll('[data-media-id]').forEach(function (li) {
        li.classList.toggle('is-active', li === slide);
      });
      lista.scrollTo({ left: slide.offsetLeft - primero.offsetLeft });
    });
  }

  /* Un fotograma de margen: con defer el DOM ya esta, pero el carrusel puede no
     haber repartido anchos todavia y offsetLeft saldria a cero. */
  requestAnimationFrame(alinearAlCargar);
})();
